import InfoIcon from '../Icons/InfoIcon'

const InfoIconBlock = ({ info_msg }) => {
  return (
    <div className="info_icon_block">
      <InfoIcon className="info_icon" />
      <span className="info_icon_msg">{info_msg}</span>
    </div>
  )
}

export default InfoIconBlock
